import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";


export function ActionNotSupportedAlert({
  open,
  setOpen,
  title = "Please use the desktop application for a better experience.",
  isTruink = false,
  subline="This action is not available in mobile view."
}) {
  const handleClose = () => setOpen(false);

  const themeColor = isTruink ? "#571B2E" : "#19433E";
  const borderColor = isTruink
    ? "rgba(87,27,46,0.12)"
    : "rgba(25,67,62,0.12)";
  const headerBg = isTruink
    ? "rgba(87,27,46,0.04)"
    : "rgba(25,67,62,0.04)";
  const iconBtnColor = isTruink
    ? "rgba(87,27,46,0.5)"
    : "rgba(25,67,62,0.5)";
  const iconBtnHoverBg = isTruink
    ? "rgba(87,27,46,0.08)"
    : "rgba(25,67,62,0.08)";
  const bodyTextColor = isTruink
    ? "rgba(87,27,46,0.7)"
    : "rgba(25,67,62,0.7)";

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          bgcolor: "rgba(0,0,0,0.4)",
          backdropFilter: "blur(2px)",
        }}
      >
        <Box
          sx={{
            width: { xs: "90vw", sm: "420px" },
            borderRadius: "16px",
            background: "#fff",
            boxShadow: "0 12px 40px rgba(0,0,0,0.18)",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 2.5,
              py: 1.75,
              borderBottom: `1px solid ${borderColor}`,
              background: headerBg,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <WarningAmberRoundedIcon
                sx={{ color: themeColor, fontSize: 22 }}
              />
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  color: themeColor,
                  letterSpacing: "0.01em",
                }}
              >
                Action Not Available
              </Typography>
            </Box>

            <IconButton
              size="small"
              onClick={handleClose}
              sx={{
                color: iconBtnColor,
                "&:hover": {
                  color: themeColor,
                  background: iconBtnHoverBg,
                },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box sx={{ px: 3, pt: 3, pb: 3.5 }}>
            <Typography
              sx={{
                color: themeColor,
                fontWeight: 800,
                fontSize: "1rem",
                mb: 0.75,
                lineHeight: 1.4,
              }}
            >
              {subline}
            </Typography>

            <Typography
              sx={{
                color: bodyTextColor,
                lineHeight: 1.75,
                fontSize: "0.9rem",
              }}
            >
              {title}
            </Typography>
          </Box>

          <Box
            sx={{
              px: 3,
              pb: 3,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Box
              component="button"
              onClick={handleClose}
              sx={{
                px: 2.5,
                py: 1,
                borderRadius: "8px",
                color: "#fff",
                fontWeight: 600,
                fontSize: "0.875rem",
                border: "none",
                cursor: "pointer",
                background: themeColor,
                transition: "background 0.15s",
                "&:hover": { background: themeColor },
                "&:active": { background: themeColor },
              }}
            >
              Got it
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}